import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mahimtopunecab() {



const cardData = {
  keyword: " Mahim to Pune Cab Service  ",

headingDescription: "Velocity Cab provides reliable and comfortable Mahim to Pune cab services, ensuring a smooth and hassle-free journey for business trips, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Mahim to Pune convenient and stress-free. The journey covers approximately 150–160 km via the Mumbai–Pune Expressway, typically taking 3–4 hours depending on traffic conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mahim to Pune cab travel.",

topPlaces: [
 
  {
    title: "Pune Okayama Friendship Garden",
    description: "Pune Okayama Friendship Garden is a serene Japanese-style garden featuring lush greenery, water streams, and beautifully designed walking paths. It is an ideal place for relaxation, photography, and peaceful nature walks."
  },
  {
    title: "Aga Khan Palace",
    description: "Aga Khan Palace is a historically significant monument linked to India’s freedom movement. It features elegant architecture, spacious gardens, and a museum dedicated to Mahatma Gandhi and important historical events."
  },
  {
    title: "Parvati Hill",
    description: "Parvati Hill is a popular heritage site in Pune offering panoramic city views from its hilltop temples. Visitors can climb the steps to explore ancient shrines and enjoy a peaceful, scenic environment."
  },
   {
    title: "Dagdusheth Halwai Ganpati Temple",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered spiritual landmarks dedicated to Lord Ganesha. Devotees and travelers can experience divine blessings, beautifully decorated idols, and a vibrant atmosphere, especially during major festivals like Ganesh Chaturthi."
  },
  {
    title: "Shaniwar Wada",
    description: "Shaniwar Wada is a historic fortification in Pune that once served as the seat of the Peshwas of the Maratha Empire. Visitors can explore its grand gateways, ruins, and enjoy the evening light and sound show that narrates Pune’s royal history."
  },
  {
    title: "Saras Baug",
    description: "Saras Baug is a well-known garden in Pune featuring lush green spaces and the famous Siddhivinayak Temple. It is a favorite spot for families, walkers, and visitors seeking relaxation in the city."
  },
  {
    title: "Bund Garden",
    description: "Bund Garden is a riverside park offering greenery, walking tracks, and boating facilities. It is a peaceful location for evening strolls and leisure activities in Pune."
  },
  {
    title: "Raja Dinkar Kelkar Museum",
    description: "Raja Dinkar Kelkar Museum showcases a rich collection of Indian artifacts, including sculptures, musical instruments, and cultural items that reflect India’s heritage and traditions."
  },
  {
    title: "Phoenix Marketcity Pune",
    description: "Phoenix Marketcity Pune is a popular shopping and entertainment hub featuring international brands, restaurants, cinemas, and entertainment zones, making it ideal for leisure and shopping experiences."
  },
  {
    title: "Pataleshwar Cave Temple",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It is known for its spiritual ambiance and historical significance in Pune."
  }
],



services: [
{
name: "Mahim to Pune Cab",
description: "Mahim to Pune cab service offers safe and reliable intercity travel with comfortable vehicles and experienced drivers. This service is perfect for personal trips, business travel, and family journeys. Customers can choose from sedan, SUV, and premium vehicles based on their needs. Timely pickup and drop ensure a smooth journey. Transparent pricing helps customers plan their travel budget easily. Flexible booking options make travel convenient. It is one of the most preferred cab services for Mahim to Pune travel."
},
{
name: "Mahim to Pune Cab Service",
description: "Mahim to Pune cab service provides dependable transportation with well-maintained vehicles and professional drivers. This service is ideal for long-distance travel with comfort and safety. Multiple vehicle options are available including sedan, SUV, and Innova. Transparent billing ensures no hidden charges. Flexible pickup and drop options enhance convenience. Suitable for one way and round trip bookings. It ensures a hassle-free travel experience."
},
{
name: "Mahim to Pune Taxi Service",
description: "Mahim to Pune taxi service offers affordable and convenient travel solutions for passengers looking for reliable rides. Vehicles are clean and comfortable for long journeys. Professional drivers ensure safe and timely service. Ideal for airport transfers, business travel, and family trips. Transparent pricing ensures clarity in fares. Easy booking options make it convenient. It is a trusted taxi service for Mahim to Pune routes."
},
{
name: "Mahim to Pune One Way Cab",
description: "Mahim to Pune one way cab service is perfect for travelers who want economical travel without return charges. This service helps reduce travel costs compared to round trips. Customers can choose from different vehicle options based on comfort and budget. Professional drivers ensure safe and timely journeys. Transparent pricing ensures no hidden fees. Easy booking process adds convenience. It is ideal for one way travel."
},
{
name: "Mahim to Pune Taxi Fare",
description: "Mahim to Pune taxi fare is designed to be affordable and transparent for all travelers. Pricing depends on vehicle type, trip type, and distance covered. Customers receive complete fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
},
{
name: "Mahim to Pune Cab Booking",
description: "Mahim to Pune cab booking provides a quick and easy way to reserve your cab with instant confirmation. Customers can book online or via phone. Multiple vehicle options are available to suit different travel needs. Professional drivers ensure timely pickups and safe journeys. Transparent pricing ensures clarity in billing. Flexible scheduling options enhance convenience. It ensures a smooth booking experience."
},
{
name: "Cab from Mahim to Pune",
description: "Cab from Mahim to Pune offers comfortable and reliable transportation for intercity travel. This service is suitable for family trips, corporate travel, and personal journeys. Vehicles are well-maintained and equipped for long-distance travel. Professional drivers ensure smooth and safe rides. Flexible booking options make planning easy. Transparent pricing ensures no hidden charges. It is a convenient travel option."
},
{
name: "Mahim to Pune Car Rental",
description: "Mahim to Pune car rental service offers flexible and private travel options for customers who prefer comfort and convenience. Customers can choose from a range of vehicles including sedan, SUV, and premium cars. Well-maintained vehicles ensure a smooth journey. Professional drivers ensure safety and reliability. Transparent pricing ensures clear billing. Flexible rental plans suit various travel needs. It is ideal for both short and long trips."
},
{
name: "Mahim to Pune Taxi Booking Online",
description: "Mahim to Pune taxi booking online allows customers to book their cab quickly and conveniently from anywhere. Customers can compare vehicle options and fares easily. Instant confirmation ensures quick travel planning. Professional drivers ensure safe and timely service. Transparent pricing avoids hidden charges. Flexible booking options enhance convenience. It is the best way to book your cab online."
},
{
name: "Cheap Cab Mahim to Pune",
description: "Cheap cab Mahim to Pune provides budget-friendly travel options for passengers looking for economical rides. This service ensures comfortable travel at affordable rates. Vehicles are clean and well-maintained for safe journeys. Professional drivers ensure smooth travel experience. Transparent pricing ensures no hidden costs. Flexible booking options add convenience. It is ideal for budget-conscious travelers."
},
{
name: "Mahim to Pune Outstation Cab",
description: "Mahim to Pune outstation cab service provides reliable transportation for long-distance travel with comfort and safety. This service is suitable for family trips, corporate travel, and weekend getaways. Vehicles are maintained for highway journeys ensuring smooth rides. Professional drivers ensure safe and timely travel. Flexible options include one way and round trips. Transparent pricing ensures clear billing. It is a trusted choice for outstation travel."
},
{
name: "Mahim to Pune AC Taxi Service",
description: "Mahim to Pune AC taxi service offers comfortable and air-conditioned travel for passengers seeking a premium experience. Vehicles are clean, well-maintained, and equipped with AC for a pleasant journey. Professional drivers ensure safe and smooth rides. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is ideal for comfortable long-distance travel."
},
{
name: "Mahim to Pune Innova Cab",
description: "Mahim to Pune Innova cab service provides spacious and comfortable travel for families and groups. This service is ideal for long-distance journeys with extra seating and luggage space. Vehicles are well-maintained and suitable for highway travel. Professional drivers ensure safe and smooth journeys. Transparent pricing ensures clarity in fares. Flexible booking options make it convenient. It is a preferred choice for group travel."
},
{
name: "Mahim to Pune SUV Taxi",
description: "Mahim to Pune SUV taxi service offers powerful and comfortable vehicles for long-distance travel. This service is ideal for group travel, family trips, and corporate journeys. Vehicles provide ample space and smooth highway performance. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden costs. Flexible booking options enhance convenience. It is a great option for SUV travel."
},
{
name: "Mahim to Pune Cab Price",
description: "Mahim to Pune cab price is structured to provide affordable and transparent fares for all types of travelers. Pricing varies based on vehicle type, trip type, and travel requirements. Customers receive clear fare details before booking. No hidden charges ensure trust and reliability. Competitive pricing makes it budget-friendly. Flexible options allow customers to choose according to their needs. It helps in easy travel planning."
},
{
name: "Mahim to Pune Sedan Cab",
description: "Mahim to Pune sedan cab service offers comfortable and economical travel for individuals and small families. Sedans are ideal for smooth rides with good mileage and comfort. Vehicles are clean and well-maintained. Professional drivers ensure safe and timely service. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is a great option for budget-friendly travel."
},
{
name: "Mahim to Pune Ertiga Cab",
description: "Mahim to Pune Ertiga cab service provides a perfect option for group travel with comfortable seating and ample space. This service is ideal for family trips and small groups. Vehicles are well-maintained and suitable for long-distance journeys. Professional drivers ensure safe travel. Transparent pricing ensures clarity in fares. Flexible booking options enhance convenience. It is a popular choice for group travel."
},
{
name: "Mahim to Pune Innova Crysta Cab",
description: "Mahim to Pune Innova Crysta cab service offers premium and luxurious travel for customers seeking extra comfort. This service is ideal for business travel and family trips. Vehicles provide spacious seating and advanced comfort features. Professional drivers ensure smooth and safe journeys. Transparent pricing ensures no hidden charges. Flexible booking options make it convenient. It is a top choice for premium travel."
},
{
name: "Mahim to Pune Private Cab",
description: "Mahim to Pune private cab service offers exclusive and personalized travel for customers who prefer privacy and comfort. This service is ideal for families, couples, and business travelers. Vehicles are well-maintained and comfortable for long journeys. Professional drivers ensure safe and reliable service. Transparent pricing ensures clear billing. Flexible booking options add convenience. It is perfect for private travel."
},
{
name: "Mahim to Pune Airport Cab",
description: "Mahim to Pune airport cab service provides reliable transportation for airport transfers with timely pickups and drops. This service is ideal for passengers traveling to or from Mumbai Airport to Pune. Drivers track flight timings to ensure punctual service. Vehicles are clean and comfortable. Transparent pricing ensures no hidden charges. Flexible booking options make it easy to plan travel. It ensures a stress-free airport journey."
},
{
name: "Best Cab Service Mahim to Pune",
description: "Best cab service Mahim to Pune offers high-quality transportation with a focus on comfort, safety, and reliability. This service is widely preferred by customers for its professional drivers and well-maintained vehicles. Transparent pricing ensures fair fares. Flexible booking options enhance convenience. Suitable for all types of travel needs. It ensures a premium and dependable travel experience."
}
],

tableData: [
["Mahim to Pune Cab","Mahim to Pune Taxi Service"],
["Mahim to Pune One Way Cab","Mahim to Pune Cab Booking"],
["Cheap Cab Mahim to Pune","Mahim to Pune Outstation Cab"],
["Mahim to Pune Innova Cab","Mahim to Pune SUV Taxi"],
["Mahim to Pune Cab Price","Mahim to Pune Sedan Cab"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Intercity Travel",
    WhyChoosedescription: "Velocity Cabs offers reliable Mahim to Pune cab service for a smooth and comfortable journey via the Mumbai Pune Expressway, ideal for business trips, family travel, and weekend getaways."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mahim to Pune routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides clear and transparent pricing for Mahim to Pune cab bookings. Customers receive full fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mahim to Pune cab service operates 24/7. Whether you need early morning pickup or late-night travel, we ensure reliable cab availability anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and same-day return trips between Mahim and Pune."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mahim to Pune cab bookings due to punctual drivers, clean vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mahim to Pune cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mahim to Pune for one-way and round-trip travel." },
  { question: "How far is Pune from Mahim?", answer: "The distance between Mahim and Pune is approximately 150 to 170 km and travel time is around 3.5 to 4.5 hours depending on traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mahim to Pune cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mahim to Pune." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mahim to Pune cabs online or through phone booking." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, societies, and offices across Mahim." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and peak travel hours." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Imran Khan",
    feedback:
      "The Mahim to Pune cab journey was very smooth and well-coordinated. The pickup was on time, the cab was comfortable, and the ride felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Patil",
    feedback:
      "Traveling from Mahim to Pune was a pleasant experience. The vehicle was clean, the drive was steady, and the overall service felt reliable and professional.",
    rating: 5
  }
];




















const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mahimPuneCabJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mahim to Pune Cab Service | Velocity Cabs",
  "description": "Book a private cab from Mahim to Pune for comfortable outstation travel. AC, Sedan, Innova, Ertiga, and SUV taxis available for one-way or round trips at affordable fares.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mahim, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mahim to Pune Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab from Mahim to Pune",
        "description": "Private cab from Mahim to Pune for one-way travel with AC, SUV, Sedan, Innova, or Ertiga options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Mahim to Pune Cab",
        "description": "Comfortable round-trip cab service from Mahim to Pune with private AC, SUV, Sedan, Innova, or Ertiga options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mahim to Pune Cab Service | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mahim to Pune for comfortable outstation travel. AC, Sedan, Innova, Ertiga, and SUV taxis available for one-way or round trips at affordable fares."
  />
  <script type="application/ld+json">
    {JSON.stringify(mahimPuneCabJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/115.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mahimtopunecab;